import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroTestimonial from "../components/HeroTestimonial";
import Testimonialsc from "../components/Testimonialsc";
import WhyChooseUs from "../components/WhyChooseUs";
import FAQtestimonials from "../components/FAQtestimonials";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";
export default function Testimonials() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <HeroTestimonial />
      <Testimonialsc />
      <WhyChooseUs />
      <FAQtestimonials />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
